import {
    GET_BOOKING_LIST,
    GET_BOOKING_LIST_SUCCESS,
    CREATE_BOOKING,
    CREATE_BOOKING_SUCCESS,
    UPDATE_BOOKING,
    UPDATE_BOOKING_SUCCESS,
    DELETE_BOOKING,
    GET_BOOKING_BY_ID,
    GET_BOOKING_BY_ID_SUCCESS,
    GET_AVAILABLE_ROOMS,
    GET_AVAILABLE_ROOMS_SUCCESS,
    GET_AVAILABLE_ROOMS_ERROR,
    CHANGE_ROOM,
    CHANGE_ROOM_SUCCESS,
    CHANGE_ROOM_ERROR,
    UPGRADE_ROOM,
    UPGRADE_ROOM_SUCCESS,
    UPGRADE_ROOM_ERROR,
    GET_BOOKINGS_BY_PATIENT,
    GET_BOOKINGS_BY_PATIENT_SUCCESS,
} from '../storeTypes';

const initialState = {
    bookingList: [],
    bookingData: {},
    patientBookings: [],
    patientBookingsLoading: false,
    availableRooms: null,
    availableRoomsLoading: false,
    availableRoomsError: null,
    loader: false,
    error: null,
};

const BookingReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BOOKING_LIST:
            return { ...state, loader: true };
        case GET_BOOKING_LIST_SUCCESS:
            return { ...state, bookingList: action.payload, loader: false };
        case CREATE_BOOKING:
            return { ...state, loader: true };
        case CREATE_BOOKING_SUCCESS:
            return { ...state, loader: false };
        case UPDATE_BOOKING:
            return { ...state, loader: true };
        case UPDATE_BOOKING_SUCCESS:
            return { ...state, loader: false };
        case CHANGE_ROOM:
            return { ...state, loader: true };
        case CHANGE_ROOM_SUCCESS:
            return { ...state, loader: false };
        case CHANGE_ROOM_ERROR:
            return { ...state, loader: false, error: action.error };
        case UPGRADE_ROOM:
            return { ...state, loader: true };
        case UPGRADE_ROOM_SUCCESS:
            return { ...state, loader: false };
        case UPGRADE_ROOM_ERROR:
            return { ...state, loader: false, error: action.error };
        case DELETE_BOOKING:
            return { ...state, loader: true };
        case GET_BOOKING_BY_ID:
            return { ...state, loader: true };
        case GET_BOOKING_BY_ID_SUCCESS:
            return { ...state, bookingData: action.payload, loader: false };
        case GET_AVAILABLE_ROOMS:
            return { ...state, availableRoomsLoading: true, availableRoomsError: null, availableRooms: null };
        case GET_AVAILABLE_ROOMS_SUCCESS:
            return { ...state, availableRooms: action.payload, availableRoomsLoading: false, availableRoomsError: null };
        case GET_AVAILABLE_ROOMS_ERROR:
            return { ...state, availableRoomsLoading: false, availableRoomsError: action.error };
        case GET_BOOKINGS_BY_PATIENT:
            return { ...state, patientBookingsLoading: true };
        case GET_BOOKINGS_BY_PATIENT_SUCCESS:
            return { ...state, patientBookings: action.payload, patientBookingsLoading: false };
        default:
            return state;
    }
};

export default BookingReducer;
